import React, { Component } from 'react'

class Home extends Component {
	componentDidMount() {
		document.title = 'Vishal Gautam'
	}
	render() {
		return <div className="Home"> Home Page </div>
	}
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/Home.js